module.exports = __webpack_public_path__ + "static/media/logo.f5262f4b.svg";